import { Icon, Style } from "ol/style";
import { Switchboard } from "../../lib/events";
import { async_forEach, get_sequential_diff } from "../../lib/misc/array";
import { None } from "../../lib/misc/option";
import { BaseActionWithNav } from "./BaseActionWithNav";
export class SetMarkersAction extends BaseActionWithNav {
    constructor(p_layer, m_layer) {
        super('SET MARKERS');
        this.p_layer = p_layer;
        this.m_layer = m_layer;
        this.context = "selection";
        this.emitter = Switchboard.get_emitter("CONTEXT");
        this.receiver = Switchboard.get_receiver("CONTEXT");
        this.prior_universe = [];
        this.prior_selected = [];
        this.receiver.on('ctx_change', (ctx => {
            if (ctx.name !== this.context) {
                this.reset();
            }
        }));
    }
    reset() {
        this.prior_selected = [];
        this.prior_universe = [];
    }
    validate(message) {
        return super.validate(message)
            && message.selected
            && Array.isArray(message.selected)
            && message.universe
            && Array.isArray(message.universe);
    }
    on_valid_message() { this.emitter.emit('ctx_request', 'selection'); }
    async interpret(message) {
        if (this.p_layer.colorized) {
            this.p_layer.clear();
            this.p_layer.use_base_style();
        }
        let { adds, subs } = get_sequential_diff(this.prior_universe, message.universe);
        if (adds.length > 0)
            await this.p_layer.add_features_by_ids(adds);
        if (subs.length > 0)
            this.p_layer.remove_features_by_ids(subs);
        this.prior_universe = message.universe;
        let { adds: m_adds, subs: m_subs } = get_sequential_diff(this.prior_selected, message.selected);
        await async_forEach(m_adds, async (strap) => await this.m_layer.add_marker_to_parcel(strap));
        await async_forEach(m_subs, async (strap) => this.m_layer.remove_marker_from_parcel(strap));
        const selected_marker = this.m_layer.markers.find(m => m.get('strap') === message.universe[0]);
        selected_marker === null || selected_marker === void 0 ? void 0 : selected_marker.setStyle(new Style({
            image: new Icon({
                anchor: [0.5, 1],
                opacity: 1.0,
                scale: 0.05,
                src: '../../../../../../img/gis/map-marker-icon-sel.png'
            })
        }));
        this.p_layer.select_feature(message.universe[0]);
        this.prior_selected = message.selected;
    }
    after_valid_message() {
        return {
            context: '',
            zoom: true,
            center: false,
            fail: false,
            navigate: None.instance()
        };
    }
}
